import { IonBadge, IonIcon } from '@ionic/react';
import { arrowDownCircle } from 'ionicons/icons';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import './scratchpad-bucket-version-badge.css';

interface ScratchpadBucketVersionBadgeProps {
  currentVersion: number;
  referenceVersion: number;
  onClick?: (e: React.MouseEvent) => void;
}

export const ScratchpadBucketVersionBadge = ({
  currentVersion,
  referenceVersion,
  onClick,
}: ScratchpadBucketVersionBadgeProps): ReactElement | null => {
  const { i18n } = useTranslation();

  if (currentVersion <= referenceVersion) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onClick?.(e);
  };

  return (
    <div
      className="version-badge-container"
      onClick={handleClick}
      role="button"
      aria-label={i18n.t('common:beacon_app_update_available')}
    >
      <IonBadge color="primary" className="version-badge">
        <IonIcon icon={arrowDownCircle} size="small" />
        {i18n.t('common:beacon_app_update_available')}
      </IonBadge>
    </div>
  );
};
